module.exports = __webpack_public_path__ + "static/img/币币交易-banner3.c4f61cd5.png";